// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2FpA2","colMin":"styles_colMin__3zuSd","colCheckbox":"styles_colCheckbox__2-0F5"};